import { createContext, useContext } from "react";
import type { Me } from "./types";

export type AuthState = {
  user: Me | null;
  setUser: (u: Me | null) => void;
};

export const AuthContext = createContext<AuthState>({
  user: null,
  setUser: () => {},
});

export function useAuth() {
  return useContext(AuthContext);
}